
import { CKEditor } from "@ckeditor/ckeditor5-react";

import {
  BlockQuote,
  Bold,
  ClassicEditor,
  CodeBlock,
  Essentials,
  FileRepository,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  Heading,
  Highlight,
  Image,
  ImageInsertUI,
  ImageToolbar,
  ImageUpload,
  Italic,
  Link,
  List,
  MediaEmbed,
  SourceEditing,
  Strikethrough,
  Table,
  TableToolbar,
  Underline,
} from "ckeditor5";

import "@ckeditor/../ckeditor5/dist/ckeditor5.css";
import coreTranslations from "@ckeditor/../ckeditor5/dist/translations/ko.js";

const editorConfiguration = {
  toolbar: [
    "undo",
    "redo",
    "|",
    "heading",
    "|",
    // "fontFamily",
    "fontSize",
    "fontColor",
    "fontBackgroundColor",
    "|",
    "bold",
    "italic",
    "underline",
    "strikethrough",
    "highlight",
    "|",
    "link",
    "bulletedList",
    "numberedList",
    "blockQuote",
    "insertTable",
    "|",
    "imageUpload",
    "mediaEmbed",
    "|",
    "codeBlock",
    "sourceEditing",
  ],
  plugins: [
    Essentials,
    Heading,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    FontColor,
    FontFamily,
    FontBackgroundColor,
    FontSize,
    Highlight,
    Link,
    List,
    BlockQuote,
    Table,
    TableToolbar,
    Image,
    ImageToolbar,
    ImageUpload,
    ImageInsertUI,
    FileRepository,
    MediaEmbed,
    CodeBlock,
    SourceEditing,
  ],
  codeBlock: {
    languages: [
      { language: 'plaintext', label: 'Plain text' },
      { language: 'html', label: 'HTML' },
      { language: 'css', label: 'CSS' },
      { language: 'javascript', label: 'JavaScript' },
      { language: 'java', label: 'Java' },
      { language: 'json', label: 'JSON' },
      { language: 'sql', label: 'SQL' },
    ],
  },
  translations: [
    coreTranslations
  ]
};

const DefaultCKEditor = ({ config, ...props }) => {
    

  return (
    <CKEditor
      editor={ClassicEditor}
      config={{
        ...editorConfiguration,
        ...config,
        }}
      {...props}
    />
  );
};

export default DefaultCKEditor;
